export default "__VITE_ASSET__b8d0c82a__"